/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Address from './Address';
import UserBase from './UserBase';

/**
 * The UserUpdate model module.
 * @module model/UserUpdate
 * @version 1.1.0
 */
class UserUpdate {
    /**
     * Constructs a new <code>UserUpdate</code>.
     * Partial update; all fields optional. Only provided fields are modified.
     * @alias module:model/UserUpdate
     * @implements module:model/UserBase
     */
    constructor() { 
        UserBase.initialize(this);
        UserUpdate.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UserUpdate</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserUpdate} obj Optional instance to populate.
     * @return {module:model/UserUpdate} The populated <code>UserUpdate</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserUpdate();
            UserBase.constructFromObject(data, obj);

            if (data.hasOwnProperty('firstName')) {
                obj['firstName'] = ApiClient.convertToType(data['firstName'], 'String');
            }
            if (data.hasOwnProperty('lastName')) {
                obj['lastName'] = ApiClient.convertToType(data['lastName'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('phoneNumber')) {
                obj['phoneNumber'] = ApiClient.convertToType(data['phoneNumber'], 'String');
            }
            if (data.hasOwnProperty('fireDeptId')) {
                obj['fireDeptId'] = ApiClient.convertToType(data['fireDeptId'], 'String');
            }
            if (data.hasOwnProperty('address')) {
                obj['address'] = ApiClient.convertToType(data['address'], Address);
            }
            if (data.hasOwnProperty('isAdmin')) {
                obj['isAdmin'] = ApiClient.convertToType(data['isAdmin'], 'Boolean');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
            if (data.hasOwnProperty('notes')) {
                obj['notes'] = ApiClient.convertToType(data['notes'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UserUpdate</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UserUpdate</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['firstName'] && !(typeof data['firstName'] === 'string' || data['firstName'] instanceof String)) {
            throw new Error("Expected the field `firstName` to be a primitive type in the JSON string but got " + data['firstName']);
        }
        // ensure the json data is a string
        if (data['lastName'] && !(typeof data['lastName'] === 'string' || data['lastName'] instanceof String)) {
            throw new Error("Expected the field `lastName` to be a primitive type in the JSON string but got " + data['lastName']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['phoneNumber'] && !(typeof data['phoneNumber'] === 'string' || data['phoneNumber'] instanceof String)) {
            throw new Error("Expected the field `phoneNumber` to be a primitive type in the JSON string but got " + data['phoneNumber']);
        }
        // ensure the json data is a string
        if (data['fireDeptId'] && !(typeof data['fireDeptId'] === 'string' || data['fireDeptId'] instanceof String)) {
            throw new Error("Expected the field `fireDeptId` to be a primitive type in the JSON string but got " + data['fireDeptId']);
        }
        // validate the optional field `address`
        if (data['address']) { // data not null
          Address.validateJSON(data['address']);
        }
        // ensure the json data is a string
        if (data['notes'] && !(typeof data['notes'] === 'string' || data['notes'] instanceof String)) {
            throw new Error("Expected the field `notes` to be a primitive type in the JSON string but got " + data['notes']);
        }

        return true;
    }


}



/**
 * @member {String} firstName
 */
UserUpdate.prototype['firstName'] = undefined;

/**
 * @member {String} lastName
 */
UserUpdate.prototype['lastName'] = undefined;

/**
 * @member {String} email
 */
UserUpdate.prototype['email'] = undefined;

/**
 * @member {String} phoneNumber
 */
UserUpdate.prototype['phoneNumber'] = undefined;

/**
 * @member {String} fireDeptId
 */
UserUpdate.prototype['fireDeptId'] = undefined;

/**
 * @member {module:model/Address} address
 */
UserUpdate.prototype['address'] = undefined;

/**
 * @member {Boolean} isAdmin
 */
UserUpdate.prototype['isAdmin'] = undefined;

/**
 * @member {Boolean} enabled
 */
UserUpdate.prototype['enabled'] = undefined;

/**
 * @member {String} notes
 */
UserUpdate.prototype['notes'] = undefined;


// Implement UserBase interface:
/**
 * @member {String} firstName
 */
UserBase.prototype['firstName'] = undefined;
/**
 * @member {String} lastName
 */
UserBase.prototype['lastName'] = undefined;
/**
 * @member {String} email
 */
UserBase.prototype['email'] = undefined;
/**
 * @member {String} phoneNumber
 */
UserBase.prototype['phoneNumber'] = undefined;
/**
 * @member {String} fireDeptId
 */
UserBase.prototype['fireDeptId'] = undefined;
/**
 * @member {module:model/Address} address
 */
UserBase.prototype['address'] = undefined;
/**
 * @member {Boolean} isAdmin
 */
UserBase.prototype['isAdmin'] = undefined;
/**
 * @member {Boolean} enabled
 */
UserBase.prototype['enabled'] = undefined;
/**
 * @member {String} notes
 */
UserBase.prototype['notes'] = undefined;




export default UserUpdate;

